import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MusicanContracts.html?raw';

//import demoData = require('dojo/text!./data.json');

import StaticTable from '../../../../moreCore/UI/StaticTable/StaticTable';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import AddressWizard from '../../../AddressWizard/AddressWizard';

class MusicanContracts extends compose(_WidgetBaseSP) {
    templateString: any = template;

    tableContainer: HTMLDivElement;

    tableLayout: object;

  
    createTable(data: any): void {
        this.UiModder.domConstruct.empty(this.tableContainer);
        let table = new StaticTable();

        table.setTableLayout(this.tableLayout as any);
        table.setRowClick(lang.hitch(this, this._showDetailDialog));
        table.setData(data);

        table.setCyAttribute("MusicianContracts");

        this.UiModder.domConstruct.place(table.domNode, this.tableContainer);
        //this.StandbyStop();

        this.emit("tableCreated");
    }

    _showDetailDialog(row: StaticTable.StaticTableRow<any>, data: StaticTable.StaticTableRowGroup<any>) {
        console.log(row.rowGroup.entity);
        //BookingDetailsView

        let dlg = new GenericDialog();
        dlg.set("header", row.rowGroup.entity.ref_associate.gDisp_Name_Firstname);
        dlg.set("topCloseBtn", true);
        dlg.setCloseOnEscape(true);
        dlg.set("closeBtn", true);

        let form = new AddressWizard();
        form.loadAddress(row.rowGroup.entity.ref_associate.ref_person.ID);
        form.startup();

        dlg.addNodeToContent(form.domNode);

        dlg.show();
    }

    _loadDataResponse(response): void {

        this.tableLayout = response.layouts[0];

        this.createTable(response.entitylist);        
    }

    _onLoadDataError(error): void {
        console.log("_onLoadDataError", error);
    }


    table_formatterFunction(cell: StaticTable.StaticTableCell<object>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;


        return false;
    }

    loadData(): void {
        this.RequestManager.callfunction(
            "Webtool_API_MusicanContracts__Open",
            {
                
            },
            lang.hitch(this, this._loadDataResponse),
            lang.hitch(this, this._onLoadDataError)
        )
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        /*this.tableLayout = {
            "rows": [
                {
                    "attributes": [
                        "date_start",
                        "date_end",
                        "ref_vt_duty_type.code",
                        "ref_ev_booking.ref_ev_activity_status.description"
                    ],
                    "headings": [
                        "Datum von",
                        "Datum bis",
                        "Diensttyp",
                        "Aktivität"
                    ],
                    "colspans": [
                        1,
                        1,
                        1,
                        1
                    ],
                    "widths": [
                        "25ch",
                        "25ch",
                        null,
                        null,
                    ],
                    "colNamesInternal": [
                        "date_start",
                        "date_end",
                        "name",
                        "activity"
                    ],
                    "bgColors": [
                        "",
                        "",
                        "",
                        ""
                    ],
                    "txtColors": [
                        "",
                        "",
                        "",
                        ""
                    ]
                }
            ],
            "name": "default",
            "label": "Standard"
        };*/

        this.RequestManager.handleAs = "json";     
        this.loadData();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MusicanContracts);

